import React from "react";
import {
  AutocompleteInput,
  DeleteWithConfirmButton,
  Edit,
  ReferenceInput,
  // SelectInput,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
} from "react-admin";
// Local
import { NonInput } from "../../components";

const EditToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
    <NonInput>
      <div style={{ flex: 1 }} />
    </NonInput>
    <DeleteWithConfirmButton />
  </Toolbar>
);

const DealerBidderEdit = props => (
  <Edit mutationMode="pessimistic" {...props}>
    <SimpleForm redirect="list" toolbar={<EditToolbar />}>
      <ReferenceInput source="dealerId" reference="dealers" fullWidth>
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <TextInput source="name" autoFocus fullWidth />
    </SimpleForm>
  </Edit>
);

export default DealerBidderEdit;
